/***
 *
 *   TABLE STYLES
 *   Matches the table treatment used across ui-reference
 *   (contacts-list-view, team-users-table, ticket-list-view): uppercase
 *   text-xs head cells in text-text-secondary, hairline row borders, and a
 *   muted row hover.
 *
 *   The previous styles floated each cell to full width on mobile and used
 *   dotted borders with 20px padding.
 *
 **********/

const Style = {
    table: 'w-full caption-bottom text-sm',
    search: 'mb-4 md:mb-0',
    loading: 'relative py-8',
    badge: 'ml-0',
    empty: 'py-6',

    body: '[&_tr:last-child]:border-0',
    thead: 'hidden md:table-header-group [&_tr]:border-b [&_tr]:border-border',
    th: `h-10 px-3 text-left align-middle text-xs font-medium uppercase tracking-wide text-text-secondary
    first:pl-0 last:pr-0`,
    th_actions: 'text-right',

    sort: `cursor-pointer select-none transition-colors hover:text-text-primary
    after:ml-1.5 after:inline-block after:h-3 after:w-3 after:align-middle after:bg-contain after:opacity-50`,
    asc: `after:bg-[url('components/table/icons/ico-sort-asc.svg')]`,
    desc: `after:bg-[url('components/table/icons/ico-sort-dsc.svg')]`,

    // Stacked cards below md, a real table row above it.
    row: 'border-b border-border transition-colors hover:bg-muted/40',
    cell: `block px-0 py-1 align-middle text-text-primary
    md:table-cell md:px-3 md:py-2.5 md:first:pl-0 md:last:pr-0`,

    actions: `flex flex-wrap items-center gap-1 py-2
    md:table-cell md:whitespace-nowrap md:text-right`,
    actionButton: 'inline-flex bg-transparent',
};

export default Style;
